'use client';

const requiredLabel = "Required";
export {
  requiredLabel
};
